import {Button, Heading, Stack, useTheme, VStack} from '@chakra-ui/react'
import {useRouter} from 'next/router'
import {goToPortal} from '../../utils/stripeHelper'
import {useAuth} from '../../hooks/useAuth'
import useTranslation from 'next-translate/useTranslation'

const SubscriptionManagement = () => {
  const theme = useTheme()
  const {t} = useTranslation('subscription')
  const {publicUser} = useAuth().state
  const router = useRouter()

  if (!publicUser) return <></>

  const {stripeCustomerId, stripeSubscriptionId} = publicUser

  return (
    <>
      {stripeCustomerId && stripeSubscriptionId && (
        <VStack
          w='full'
          p={7}
          spacing={5}
          borderRadius={theme.radii.big}
          background={theme.colors.layers.appLevel1}
          align='flex-start'>
          <Heading variant='small' color={theme.colors.text.basic}>
            {t('subscription_manage_title')}
          </Heading>
          <Stack
            spacing={5}
            direction={['column', 'column', 'column', 'row', 'row', 'row']}
            w='full'>
            <Button
              variant='socialLogin'
              w={['full', 'full', 'full', 'auto', 'auto', 'auto']}
              onClick={async () => {
                await goToPortal(stripeCustomerId, stripeSubscriptionId, router)
              }}>
              {t('subscription_manage_card')}
            </Button>
            <Button
              variant='socialLogin'
              w={['full', 'full', 'full', 'auto', 'auto', 'auto']}
              onClick={async () => {
                await goToPortal(stripeCustomerId, stripeSubscriptionId, router)
              }}>
              {t('subscription_manage_invoices')}
            </Button>
          </Stack>
        </VStack>
      )}
    </>
  )
}
export default SubscriptionManagement
